import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import Avatar from '../Avatar';
import DateTime from '../DateTime';
import NotificationsText from './Text';

const NotificationsDropdownItem = ({
  notification,
  handleMarkAsRead,
  handleMarkAsUnread,
  handleDelete,
}) => {
  const intl = useIntl();

  const { definition } = notification;

  return (
    <div className={classnames('notification-item', { unread: notification.unread })}>
      <div className="notification-avatar">
        <Avatar
          id={`notification-dropdown-user-${notification.id}`}
          user={notification.user}
          expandable={true}
        />
      </div>
      <div className="notification-title">
        <NotificationsText notification={notification} />
        <div className="notification-date">
          <i className={`fas ${definition.icon}`} />
          <DateTime
            id={`notification-date-${notification.id}`}
            dateTime={notification.created_at}
          />
        </div>
      </div>
      <div className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav aria-label={intl.formatMessage({ defaultMessage: 'Actions' })}>
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem
              onClick={() => {
                if (notification.unread) {
                  handleMarkAsRead(notification.id);
                } else {
                  handleMarkAsUnread(notification.id);
                }
              }}
            >
              <i className="fas fa-check" />
              {notification.unread ? intl.formatMessage({ defaultMessage: 'Mark as read' }) :
                intl.formatMessage({ defaultMessage: 'Mark as unread' })}
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                handleDelete(notification.id);
              }}
            >
              <i className="fas fa-trash" />
              {intl.formatMessage({ defaultMessage: 'Delete' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    </div>
  );
};

NotificationsDropdownItem.propTypes = {
  notification: PropTypes.object.isRequired,
  handleMarkAsRead: PropTypes.func.isRequired,
  handleMarkAsUnread: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
};

export default NotificationsDropdownItem;
